const blocks = [
  {
    title: 'Что такое эффективность обучения',
    desc: 'Эффективность обучения — это не «хороший тренинг» и не «довольные сотрудники». Это измеримое изменение рабочих показателей: рост продаж, снижение ошибок, ускорение процессов, повышение качества обслуживания. Эффективность обучения измеряется в деньгах, времени, качестве и вовлечённости.',
    items: [
      'Исходная точка: замер KPI до обучения',
      'Процесс: обучение + практика + сопровождение',
      'Результат: измеримый рост бизнес-показателей',
    ],
  },
  {
    title: 'Чем удовлетворённость отличается от реального результата',
    desc: 'Удовлетворённость участников (уровень 1 по Киркпатрику) — это эмоциональная реакция на тренинг. Реальный результат (уровни 3-4) — это изменение поведения и влияние на бизнес-метрики. Можно провести «весёлый» тренинг, который понравится всем, но не изменит ни одного показателя.',
    items: [
      'Удовлетворённость: «Тренинг был интересный, спасибо!»',
      'Реальный результат: конверсия выросла с 12% до 18%',
      'Удовлетворённость ≠ эффективность, это разные измерения',
    ],
  },
  {
    title: 'Почему важно измерять изменения в поведении, а не только знания',
    desc: 'Знания — это потенциал. Поведение — это реализация потенциала. Сотрудник может знать все техники продаж (уровень 2), но продолжать работать по-старому. Только когда знания превращаются в ежедневные действия, появляется бизнес-результат. Между «знаю» и «делаю» — пропасть, которую заполняет внедрение.',
    items: [
      'Знания = теория, поведение = практика',
      'Без изменения поведения нет бизнес-результата',
      'Именно поведение, а не знания, влияет на прибыль',
    ],
  },
];

export default function WhatIsEffectivenessEvaluation() {
  return (
    <section id="what-is" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Что такое оценка эффективности обучения
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Оценка эффективности — это система измерения того, как обучение повлияло на работу сотрудников и бизнес-показатели компании. Отличие реальной эффективности от «понравилось/не понравилось».
        </p>

        <div className="space-y-10">
          {blocks.map((b, i) => (
            <div key={i} className="bg-white rounded-2xl p-8 border border-gray-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{b.title}</h3>
              <p className="text-gray-600 leading-relaxed mb-5">{b.desc}</p>
              <div className="space-y-2">
                {b.items.map((item, j) => (
                  <div key={j} className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-sm text-white"></i>
                    </div>
                    <span className="text-gray-700 text-sm">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}